import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadsService {

  private _leadsapiUrl = `${environment.travel}/leads`;
  private _travelapiUrl = `${environment.travel}`;

  constructor(
    private _http: HttpClient
  ) { }

  // Leads APIs

  getAllLeads(pageNo: any, pageSize: any, token: any, searchKeyword: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 20,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this._travelapiUrl}/leads`, paginationSettings);
  }

  createLead(formData: any) {
    return this._http.post<any>(`${this._leadsapiUrl}/addlead`, formData);
  }

  getLead(leadId: any) {
    return this._http.get<any>(`${this._leadsapiUrl}/lead/${leadId}`);
  }

  deleteLead(leadId: any) {
    return this._http.delete<any>(`${this._leadsapiUrl}/lead/${leadId}`);
  }

  updateLead(leadId: any, formData: any) {
    return this._http.put<any>(`${this._leadsapiUrl}/lead/${leadId}`, formData)
  }

  getLeadsOfClient(clientId: any, pageNo: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10
    }
    return this._http.post<any>(`${this._travelapiUrl}/leads/${clientId}`, paginationSettings);
  }

  getVendorDmcsmails(leadId: any, pageNo: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10
    }
    return this._http.put<any>(`${this._travelapiUrl}/vendordmcs/vendordmcsmails/${leadId}`, paginationSettings);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${this._travelapiUrl}/updateleads`, req)
  }

  bulkUploadLeads(req:any): Observable<any> {
    return this._http.post(`${this._travelapiUrl}/uploadleads`, req);
  }

  createDmcLead(packageId: any, organizationId: any):Observable<any>{
    return this._http.put<any>(`${environment.travel}/createlead/${packageId}/${organizationId}`, {})
  }

}
